import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTypedTranslation } from '@app/hooks';
import { setExceptionHandler, getModalSwitch, removeDetailsBreadcrumb, addDetailsBreadcrumb } from '@app/store/actions';
import { genericErrorToast, hasOrgPermission } from '@app/helpers';
import EditPwsAgentDialog from '@app/pages/password/dialogs/editPwsAgent';
import { IAgentDetail } from '@app/models';
import { IModalData, ModalComponent } from '@app/components';
import { vaultPasswordsService } from '@app/services';
import { ManageSystem } from '@app/store/constants';

interface IProps {
    match: {
        params: {
            id: string;
        }
    };
}

const PwsAgentDetailsPage = (props: IProps) => {
    const [agentName, setAgentName] = useState('');
    const [provisioningState, setProvisioningState] = useState('');
    const [version, setVersion] = useState('');
    const [thirdParty, setThirdParty] = useState('');

    const dispatch = useDispatch();

    const { translation } = useTypedTranslation();

    const agentId: string = props.match.params.id;

    useEffect(() => {
        dispatch(setExceptionHandler(true));

        vaultPasswordsService.getSyncAgent(agentId, handleSuccessGetAgent, genericErrorToast);

        return () => {
            dispatch(removeDetailsBreadcrumb());
        };
    }, []);

    const modalSwitchState: boolean = useSelector((state: any) => state.modal);
    const [modalData, setModalData] = useState<IModalData>({
        headerTitle: '',
        modalSwitcher: modalSwitchState
    });

    const handleSuccessGetAgent = (response: any) => {
        const results: IAgentDetail = response.data;

        if (results) {
            dispatch(addDetailsBreadcrumb(results.AgentName));

            setAgentName(results.AgentName);
            setProvisioningState(results.ProvisioningState);
            setVersion(results.Version);

            if (results.ClientId.toLowerCase().includes('thirdparty')) {
                setThirdParty(translation('YES'));
            }
            else {
                setThirdParty(translation('NO'));
            }
        }
    };

    const editAgent = () => {
        dispatch(getModalSwitch(true));
        setModalData({
            headerTitle: translation('EDIT_AGENT'),
            modalSwitcher: modalSwitchState,
            form: <EditPwsAgentDialog id={agentId} agentName={agentName} status={provisioningState}
                editAgentCompleteCallback={onEditAgentComplete}
                 />
        });
    };

    const onEditAgentComplete = (agentName: string, agentStatus: string) => {
        dispatch(getModalSwitch(false));

        setAgentName(agentName);
        setProvisioningState(agentStatus);
    };

    return (
        <>
            <ModalComponent {...modalData} />

            <div className='content--narrow detailPage'>
                <div className='detailPage__section'>
                    <div className='detailPage__section-head'>
                        {translation('AGENT_DETAILS')}
                    </div>
                    <div className='detailPage__section-content'>
                        <ul className='detailPage__list'>
                            {hasOrgPermission([ManageSystem]) &&
                                <li>
                                    <a id='editAgentLink' className='detailPage__list--primary-label' onClick={() => editAgent()}>{translation('EDIT')}</a>
                                </li>
                            }
                            <li>
                                <span className='detailPage__list--primary-label'>{translation('AGENT_NAME')}</span>
                                <span className='detailPage__list--secondary-label'>{agentName}</span>
                            </li>
                            <li>
                                <span className='detailPage__list--primary-label'>{translation('AGENT_STATE')}</span>
                                <span className='detailPage__list--secondary-label'>
                                    {/*TODO: it should be fixed on the backend one day*/}
                                    {provisioningState === 'Disabled' ? translation('PROVISION_STATE_INACTIVE') : provisioningState}</span>
                            </li>
                            <li>
                                <span className='detailPage__list--primary-label'>{translation('AGENT_VERSION')}</span>
                                <span className='detailPage__list--secondary-label'>{version}</span>
                            </li>
                            <li>
                                <span className='detailPage__list--primary-label'>{translation('THIRD_PARTY')}</span>
                                <span className='detailPage__list--secondary-label'>{thirdParty}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PwsAgentDetailsPage;